import { FullBusinessCheckIn } from 'model';
import { PostTypeViewProps } from './types.js';
import { PostContentsSummary } from '../PostContentsSummary.js';
import { BigImageContainer } from '../BigImageContainer.js';
import { LinkPreviewComponent } from '../LinkPreviewComponent.js';
import { BusinessCheckInBanner } from '../BusinessCheckInBanner.js';

// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../../styles/posts.module.css';
import { filterInlineImages } from '../../util/filterInlineImages.js';
import { PostHeader } from '../PostHeader.js';

export function BusinessCheckInView({
	post,
	testId,
	preview,
	detail,
	expanded
}: PostTypeViewProps<FullBusinessCheckIn>) {
	return (
		<>
			<PostHeader post={post} />
			<div className={postStyles.postBody} data-testid={testId}>
				<BusinessCheckInBanner businessId={post.businessId} />
				{!preview && (
					<>
						<PostContentsSummary post={post} allowExpand={detail} expanded={expanded} />
						<LinkPreviewComponent linkPreview={post.linkPreview} />
						{post.images.length > 0 && (
							<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
						)}
					</>
				)}
			</div>
		</>
	);
}
